export type AICodingState = {
  isAddAICodingJobOpened: boolean;
};

export const initialAICodingState: AICodingState = {
  isAddAICodingJobOpened: false,
};
